import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonResponse } from '../models/common-response';
import { Addon } from '../models/addon/addon';
import { AddonUniversity } from '../models/addon/addon-university';

@Injectable({
	providedIn: 'root',
})
export class AddonService {
	constructor(private _http: HttpClient) {}

	// --- ADMIN ROUTES (SuperAdmin) ---

	getAddons(): Observable<CommonResponse<Addon[]>> {
		return this._http.get<CommonResponse<Addon[]>>('/admin/addons');
	}

	getAddon(id: string): Observable<CommonResponse<Addon>> {
		return this._http.get<CommonResponse<Addon>>(`/admin/addons/${id}`);
	}

	createAddon(data: Partial<Addon>): Observable<CommonResponse<Addon>> {
		return this._http.post<CommonResponse<Addon>>('/admin/addons', data);
	}

	updateAddon(id: string, data: Partial<Addon>): Observable<CommonResponse<Addon>> {
		return this._http.put<CommonResponse<Addon>>(`/admin/addons/${id}`, data);
	}

	deleteAddon(id: string): Observable<CommonResponse<boolean>> {
		return this._http.delete<CommonResponse<boolean>>(`/admin/addons/${id}`);
	}

	// --- UNIVERSITY ROUTES ---

	getUniversityAddons(universityId: string): Observable<CommonResponse<AddonUniversity[]>> {
		return this._http.get<CommonResponse<AddonUniversity[]>>('/university/addons', {
			headers: { 'X-University': universityId },
		});
	}

	createUniversityAddon(universityId: string, data: Partial<AddonUniversity>): Observable<CommonResponse<AddonUniversity>> {
		return this._http.post<CommonResponse<AddonUniversity>>('/university/addons', data, {
			headers: { 'X-University': universityId },
		});
	}

	updateUniversityAddon(universityId: string, id: string, data: Partial<AddonUniversity>): Observable<CommonResponse<AddonUniversity>> {
		return this._http.put<CommonResponse<AddonUniversity>>(`/university/addons/${id}`, data, {
			headers: { 'X-University': universityId },
		});
	}

	deleteUniversityAddon(universityId: string, id: string): Observable<CommonResponse<boolean>> {
		return this._http.delete<CommonResponse<boolean>>(`/university/addons/${id}`, {
			headers: { 'X-University': universityId },
		});
	}
}
